<app-generic-header [goBack]="dismiss.bind(this)" variant="back">
</app-generic-header>

<ion-content class="ion-padding" *ngIf="!isNative">
    <div class="noVegglyStoreOnWeb">
        <p>{{'noVegglyStore' | translate}}</p>
    </div>
    <ion-button expand="block" class="button-edit-profile-share" shape="round" (click) = "downloadApp()">
        {{'downloadApp' | translate}}
    </ion-button>   
</ion-content>

<ion-content [class.showModal]="showProfileSharePerCarrots" class="ion-padding" *ngIf="isNative">
    <div class="storeContainer">
        <!--===| Coins |===-->
        <div class="coinStore" *ngIf="this.showingCoins">
            <div class="topicLogo">
                <img class="topicLogoMain" src="./assets/imgs/spark.svg">
            </div>
            <div class="topText">
                <h1 class="titlePage carrotsTitle">
                    {{'carrots' | translate}}
                    <div class="topicOwnedTextCoin">
                        {{ ('youOwn' | translate) + " " + coinsOwned + " " + ('coinsLowerCase' | translate)}}
                    </div>
                </h1>
                <div>
                    <div class="advantageText">
                        <swiper-container #swiper autoplay="true" pagination="true" loop="true">
                            <swiper-slide>
                                <ion-item lines="none">
                                    <ion-thumbnail item-start>
                                        <img class="advantage-icon" src="/assets/imgs/superlikeorange.svg" alt="SuperLike">
                                    </ion-thumbnail>
                                    <ion-label>
                                        <h2>{{'superLike' | translate}}</h2>
                                        <div style="padding-right: 13%;">
                                            <h3>{{'sendASuper' | translate}}</h3>
                                        </div>
                                    </ion-label>
                                </ion-item>
                            </swiper-slide>
                            <swiper-slide>
                                <ion-item lines="none">
                                    <ion-thumbnail item-start>
                                        <img class="advantage-icon" src="/assets/imgs/fireboost.svg" alt="FireBoost">
                                    </ion-thumbnail>
                                    <ion-label>
                                        <h2>{{'vegBoost' | translate}}</h2>
                                        <div>
                                            <h3>{{'activateVegBoost' | translate}} 12 {{'hours' | translate}}</h3>
                                        </div>
                                    </ion-label>
                                </ion-item>
                            </swiper-slide>
                        </swiper-container>
                    </div>
                </div>
            </div>
            <div class="storeOptions" [class.android15]="isAndroid15">
                <swiper-container #swiper class="sparks-swiper" slides-per-view="3" space-between="10" loop="false">
                    <!--| 100 Sparks |-->
                    <swiper-slide>
                        <div class="packageOption {{selection[3]}}" (click)="optionClicked(3)">
                            <div class="packageAmountContainer">
                                <span class="packageQtd"> 100 </span>
                                <span class="packageLabel">{{'coins' | translate}}</span>
                            </div>
                            <div class="packageDescriptionContainer">
                                <ng-container *ngIf="isPriceLoaded(100, 'coins'); else loading100">
                                    <p class="packageDescriptionPrice">
                                        {{getPricesString(100, 'coins')}}
                                    </p>
                                    <p class="packageDescriptionEach">
                                        {{formatMicro(getPricesNumberMicro(100, 'coins'), 100) + " " + ('each' | translate)}}
                                    </p>
                                </ng-container>
                                <ng-template #loading100>
                                    <div class="animationContainer">
                                        <p class="packageDescriptionPrice shimmerBG loading single"></p>
                                    </div>
                                </ng-template>
                            </div>
                            <span class="discountBubble">
                                <div class="discountContainer">
                                    <p class="discountAmount">
                                        {{'saveMoney' | translate}}
                                        {{formatNoDecimal(purchaseServiceProvider.hundredCoinDiscount)}}%
                                    </p>
                                </div>
                            </span>
                        </div>
                    </swiper-slide>
                    
                    <!--| 50 Sparks |-->
                    <swiper-slide>
                        <div class="packageOption {{selection[2]}}" (click)="optionClicked(2)">
                            <span class="more-populate">
                                {{'morePopulate' | translate}}
                            </span>
                            <div class="packageAmountContainer">
                                <span class="packageQtd"> 50 </span>
                                <span class="packageLabel">{{'coins' | translate}}</span>
                            </div>
                            <div class="packageDescriptionContainer">
                                <ng-container *ngIf="isPriceLoaded(50, 'coins'); else loading50">
                                    <p class="packageDescriptionPrice">
                                        {{getPricesString(50, 'coins')}}
                                    </p>
                                    <p class="packageDescriptionEach">
                                        {{formatMicro(getPricesNumberMicro(50, 'coins'), 50) + " " + ('each' | translate)}}
                                    </p>
                                </ng-container>
                                <ng-template #loading50>
                                    <div class="animationContainer">
                                        <p class="packageDescriptionPrice shimmerBG loading single"></p>
                                    </div>
                                </ng-template>
                            </div>
                            <span class="discountBubble">
                                <div class="discountContainer">
                                    <p class="discountAmount">
                                        {{'saveMoney' | translate}}
                                        {{formatNoDecimal(purchaseServiceProvider.fiftyCoinDiscount)}}%
                                    </p>
                                </div>
                            </span>
                        </div>
                    </swiper-slide>
                    
                    <!--| 10 Sparks |-->
                    <swiper-slide>
                        <div class="packageOption {{selection[1]}}" (click)="optionClicked(1)">
                            <div class="packageAmountContainer">
                                <span class="packageQtd"> 10 </span>
                                <span class="packageLabel">{{'coins' | translate}}</span>
                            </div>
                            <div class="packageDescriptionContainer">
                                <ng-container *ngIf="isPriceLoaded(10, 'coins'); else loading10">
                                    <p class="packageDescriptionPrice">
                                        {{getPricesString(10, 'coins')}}
                                    </p>
                                    <p class="packageDescriptionEach">
                                        {{formatMicro(getPricesNumberMicro(10, 'coins'), 10) + " " + ('each' | translate)}}
                                    </p>
                                </ng-container>
                                <ng-template #loading10>
                                    <div class="animationContainer">
                                        <p class="packageDescriptionPrice shimmerBG loading single"></p>
                                    </div>
                                </ng-template>
                            </div>
                            <span class="discountBubble">
                                <div class="discountContainer">
                                    <p class="discountAmount">
                                        {{'saveMoney' | translate}}
                                        {{formatNoDecimal(purchaseServiceProvider.tenCoinDiscount)}}%
                                    </p>
                                </div>
                            </span>
                        </div>
                    </swiper-slide>
                    
                    <!--| 1 Spark |-->
                    <swiper-slide>
                        <div class="packageOption {{selection[0]}}" (click)="optionClicked(0)">
                            <div class="packageAmountContainer">
                                <span class="packageQtd"> 1 </span>
                                <span class="packageLabel">{{'coin' | translate}}</span>
                            </div>
                            <div class="packageDescriptionContainer">
                                <ng-container *ngIf="isPriceLoaded(1, 'coins'); else loading1">
                                    <p class="packageDescriptionPrice">
                                        {{getPricesString(1, 'coins')}}
                                    </p>
                                </ng-container>
                                <ng-template #loading1>
                                    <div class="animationContainer">
                                        <p class="packageDescriptionPrice shimmerBG loading single"></p>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </swiper-slide>
                </swiper-container>
            </div>
        </div>
        <!--===| // |===-->
        <div class="foreground{{showingAdvantage ? ' clear' : ''}}">
            <div *ngIf="showingAdvantage" class="advantageContainerAvocadoclub">
                <div class="backArrowSection advantage">
                    <ion-button fill="clear" (click)="dismissModal()">
                        <label>
                            < </label>
                    </ion-button>
                </div>
                <div class="advantagesModalBox">
                    <div class="imgDiv">
                        <img class="avocadoLogo" src="assets/imgs/flamrplus.svg" alt="Avocadoclub">
                    </div>
                    <div class="advantageTopTextContainer">
                        <span class="advantageTitle">{{'avocadoClub' | translate}}</span><br>
                        <!--<span class="advantageSubTitle">{{'joinClub' | translate}}</span><br>-->
                    </div>
                    <ul class="advantagesList">
                        <li>{{'seeWhoLikedYou' | translate}}</li>
                        <li>{{'noAds' | translate}}</li>
                        <li>3 {{'vegglyCoins' | translate}} {{'perMonth' | translate}}</li>
                        <li>{{'teleportation' | translate}}</li>
                        <li>{{'chatReadConfirmation' | translate}}</li>
                        <li>{{'avocadoClubMemberIndicator' | translate}}</li>
                        <li>{{'goodKarmaForHelpingVegglyGrow' | translate}}</li>
                    </ul>
                    <ion-button class="purchaseButton" (click)="dismissModal()">
                        {{('join' | translate)}}
                    </ion-button>
                </div>
            </div>
        </div>
        <div class="footerButtons{{showingAdvantage ? ' blurred' : ''}}">
            <ion-button color="primary" shape="round" class="purchaseButton" (click)="buy()">
                {{!showingCoins ? ('join' | translate) : ('buy' | translate)}}
            </ion-button>
            <div *ngIf="!this.showingCoins" class="bottomText subscriptionText">
                <span (click)="openLinkPlayStore()" *ngIf="this.platform.is('android')">
                    <span [innerHTML]="'subscriptionExplanationForAndroid' | translate"></span>
                </span>
                <span *ngIf="!this.platform.is('android')">
                    {{('subscriptionExplanation' | translate)}}
                </span>
            </div>
            <div *ngIf="this.showContinueWithoutJoining">
                <ion-button (click)="dismiss()" class="continueWhithoutJoiningButton" fill=clear>{{'continueWithoutJoining'
                    | translate}}</ion-button>
            </div>
        </div>
    </div>
</ion-content>